import React from 'react';
import PropTypes from 'prop-types';
import { Box, Typography, IconButton } from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';
import ModifyIcon from '../../../../common/icons/modifyIcon';

const useStyles = makeStyles(() => ({
  image: {
    width: 20,
    height: 20,
  },
  text: {
    fontWeight: 500,
  },
  IconButton: {
    marginLeft: 20,
  },
}));

const Title = ({ ...props }) => {
  const { onClick, title, shouldModify } = props;
  const handleClick = () => {
    onClick();
  };
  const classes = useStyles();
  return (
    <Box
      display="flex"
      flexDirection="row"
      justifyContent="flex-start"
      alignContent="center"
    >
      <Typography
        variant="h2"
        className={classes.text}
        data-cy={title.split(' ').join('')}
      >
        {title}
      </Typography>
      {shouldModify && (
        <IconButton
          onClick={handleClick}
          className={classes.IconButton}
          size="small"
        >
          <ModifyIcon size="20px" color="#6A148E" />
        </IconButton>
      )}
    </Box>
  );
};

Title.propTypes = {
  title: PropTypes.string,
  onClick: PropTypes.func,
  shouldModify: PropTypes.bool,
};

export default Title;
